import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useCatalogCategory, CatalogCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<CatalogCategory>
      useData={useCatalogCategory}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
